import { render } from "./mailSignatureGenerator.vue?vue&type=template&id=a200ba48"
import script from "./mailSignatureGenerator.vue?vue&type=script&lang=js"
export * from "./mailSignatureGenerator.vue?vue&type=script&lang=js"

import "./mailSignatureGenerator.vue?vue&type=style&index=0&id=a200ba48&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__